import { FC } from 'react'

import { Text } from '@cash-me/react-components'

import * as S from './styles'

export const Legal: FC = () => (
  <S.Wrapper>
    <Text size="caption" weight="medium" color="var(--colors-neutral-background-pressed)">
      A CashMe não realiza qualquer atividade privativa de instituições financeiras, como financiamentos e/ou
      empréstimos direto a seus clientes. Nos termos da Resolução nº 4.935, de 29 de julho de 2021, do Conselho
      Monetário Nacional, a CashMe atua meramente como Correspondente Bancário de instituições financeiras, as quais, na
      qualidade de agentes bancarizadores devidamente autorizados pelo Banco Central do Brasil, figuram como credores em
      favor de terceiros em operações de crédito e empréstimos. As instituições financeiras com as quais atuamos são:
      BMP Sociedade de Crédito Direto S/A e OXY Companhia Hipotecária.
    </Text>
    <Text size="caption" weight="medium" color="var(--colors-neutral-background-pressed)">
      CASHME SOLUÇÕES FINANCEIRAS S.A., possui sede social na capital do estado de SP, à Rua Olimpíadas, 242, 7º andar,
      CEP 04551-000, na cidade de São Paulo/SP, inscrita no CNPJ sob o no 34.175.529/0001-68.
    </Text>
  </S.Wrapper>
)
